// shared-library/api/services/funnelWebApiWx.js
import sharedFunnelWebApi from '@shared-library/api/services/funnelWebApi.js'

export default function(apiClient) {
  // 使用共享库的funnelApi，并可以扩展或覆盖
  const sharedApi = sharedFunnelWebApi(apiClient);
  
  return {
    // 继承共享库的所有方法
    ...sharedApi,
    
    // 如果需要添加微信端特定的方法，可以在这里添加
  }
}